import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
// import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PortalManagementSubscriptionService } from 'src/app/features/portal/_services/management/portal-management-subscription.service';
import { NotificationService } from 'src/app/_share/_services/notification.service';
import { FormFields } from 'src/app/_share/_models/forms/form-fields.interface';

@Component({
  selector: 'app-agent-commission-dialog',
  templateUrl: './agent-commission-dialog.component.html',
  styleUrls: ['./agent-commission-dialog.component.scss']
})
export class AgentCommissionDialogComponent implements OnInit {
  data: any;
  loading = false;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private portalManagementSubscriptionService: PortalManagementSubscriptionService,
    private ns: NotificationService
  ) {}

  commissionForm: FormFields[] = [
    {
      name: 'agent_commission_paid',
      label: 'I confirm that I want to process the agent commission for this subscription.',
      type: 'checkbox',
      validators: { requiredTrue: { required: true } },
      rendered: true
    },
    {
      name: 'date_agent_commission',
      label: 'Date of Commission Payment',
      type: 'date',
      validators: { required: { required: true } },
      rendered: true
    }
  ];

  ngOnInit(): void {
    this.data = this.config.data.subscription;

    console.log('Agent Commission Dialog initialized with data: ', this.data);
  }

  processAgentCommission(formSubmission: any) {
    this.loading = true;
    console.log('Processing agent commission with data: ', formSubmission);

    this.portalManagementSubscriptionService
      .processAgentCommission(this.data.id, formSubmission)
      .subscribe({
        next: (res) => {
          this.loading = false;
          this.ref.close(true);
        },
        error: (err) => {
          console.error('Error processing agent commission', err);
          this.ns.mainError('Failed to process agent commission. Please try again.');
        }
      });
  }

  closeDialog() {
    this.ref.close();
  }
}
